export default {"src":"/_next/static/media/3.2.ee3ba774.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};